import { intlDisplayNames } from "../helpers/intlDisplayNames"
import { useTranslation } from "../libs/react-i18next"

/**
 * Hook to get a function that format a language, region and script display names..
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames
 */
export const useDisplayNames = (options: Intl.DisplayNamesOptions) => {
  const { i18n } = useTranslation()

  return intlDisplayNames({ locale: i18n.language, options })
}

/**
 * Hook to get a function that formats a region code to its name
 */
export const useDisplayRegionName = (options?: Intl.DisplayNamesOptions) => {
  return useDisplayNames({
    ...options,
    type: "region",
  })
}
